module.exports = __webpack_public_path__ + "img/view-docs.d5686a1d.svg";